import { useContext } from 'react'
import gql from 'graphql-tag'
import styled from 'styled-components'
import { PredictionOfPassedContainerContext } from '@app.feature/exam/gsat2024-2/context/PredictionOfPassedContainerContext'
import {
  calculateAgeFromTimestamp,
  parseTestResultDate,
} from '../../module/testResult.module'
import PredictionPassedMarkDesktop from './PredictionPassedMark.desktop'
import UserInfoTextLayoutDesktop from './UserInfoTextLayout.desktop'

gql`
  fragment TestUserInfoArticle_examReserveInformation on ExamReserveInformation {
    examDepartment {
      id
      name
    }
    examJob {
      id
      name
    }
    examSubsidiary {
      id
      name
    }
    examTest {
      id
      name
    }
    user {
      phoneNumber
      birthday
      username
    }
  }
`

const TestUserInfoArticleDesktop = () => {
  const { examReserveInformation, examGradingResultData, examTestsData } =
    useContext(PredictionOfPassedContainerContext)

  const examDate = parseTestResultDate({
    dateList: examTestsData || [],
    testId: examReserveInformation?.examTest.id || '',
    formatType: 'kor',
  })

  const userInfoList = [
    {
      label: '닉네임',
      value: examReserveInformation?.user.username || '',
    },
    {
      label: '생년월일',
      value: calculateAgeFromTimestamp(examReserveInformation?.user.birthday),
    },
    { label: '응시일자', value: examDate },
  ]

  const testInfoList = [
    {
      label: '계열사',
      value: examReserveInformation?.examSubsidiary.name || '',
    },
    {
      label: '사업부',
      value: examReserveInformation?.examDepartment.name || '',
    },
    { label: '직무', value: examReserveInformation?.examJob.name || '' },
  ]

  if (!examReserveInformation) return <></> // TODO 스켈레톤 처리 필요합니다

  return (
    <StyledWrapper>
      <div className="text-section">
        <UserInfoTextLayoutDesktop
          title="기본 정보"
          list={userInfoList}
          className="basic-info"
        />
        <UserInfoTextLayoutDesktop
          title="응시 정보"
          list={testInfoList}
          className="test-info"
        />
      </div>
      <PredictionPassedMarkDesktop
        topPercent={examGradingResultData?.viewerRank || 0}
      />
    </StyledWrapper>
  )
}

export default TestUserInfoArticleDesktop

const StyledWrapper = styled.article`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  border-radius: 10px;
  padding: 48px 87px;
  width: 100%;
  background-color: #fff;

  > .text-section {
    height: 129px;
    display: flex;
    align-items: center;
    gap: 96px;

    > .basic-info {
      width: 245px;
    }

    > .test-info {
      width: 330px;
    }
  }
`
